import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const PeopleIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      {...props}
    >
      <path
        d="M14.9994 5.96675C14.9494 5.95842 14.8911 5.95842 14.8411 5.96675C13.6911 5.92508 12.7744 4.98342 12.7744 3.81675C12.7744 2.62508 13.7327 1.66675 14.9244 1.66675C16.1161 1.66675 17.0744 2.63342 17.0744 3.81675C17.0661 4.98342 16.1494 5.92508 14.9994 5.96675Z"

        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M14.1412 12.0334C15.2829 12.2251 16.5412 12.0251 17.4245 11.4334C18.5995 10.6501 18.5995 9.36676 17.4245 8.58343C16.5329 7.99176 15.2579 7.79176 14.1162 7.99176"

        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M4.97539 5.96663C5.02539 5.9583 5.08372 5.9583 5.13372 5.96663C6.28372 5.92496 7.20039 4.98329 7.20039 3.81663C7.20039 2.62496 6.24206 1.66663 5.05039 1.66663C3.85873 1.66663 2.90039 2.63329 2.90039 3.81663C2.90872 4.98329 3.82539 5.92496 4.97539 5.96663Z"

        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M5.83353 12.0333C4.69186 12.225 3.43353 12.025 2.5502 11.4333C1.3752 10.65 1.3752 9.36664 2.5502 8.58331C3.44186 7.99164 4.71686 7.79163 5.85853 7.99163"

        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M10.0004 12.1916C9.95039 12.1833 9.89206 12.1833 9.84206 12.1916C8.69206 12.1499 7.77539 11.2083 7.77539 10.0416C7.77539 8.84994 8.73372 7.8916 9.92539 7.8916C11.1171 7.8916 12.0754 8.85827 12.0754 10.0416C12.0671 11.2083 11.1504 12.1583 10.0004 12.1916Z"

        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M7.57461 14.8167C6.39961 15.6 6.39961 16.8833 7.57461 17.6667C8.90794 18.5583 11.0913 18.5583 12.4246 17.6667C13.5996 16.8833 13.5996 15.6 12.4246 14.8167C11.0996 13.9333 8.90794 13.9333 7.57461 14.8167Z"

        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  )
}


